import { render } from "./RecentPosts.vue?vue&type=template&id=76743bee&scoped=true"
import script from "./RecentPosts.vue?vue&type=script&lang=js"
export * from "./RecentPosts.vue?vue&type=script&lang=js"

import "./RecentPosts.vue?vue&type=style&index=0&id=76743bee&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76743bee"]])

export default __exports__